export default (initialState = {}) => {
  return () => {
    return {
      adjustments: 0,
      adjusted_credits: 0,
      approvers: [],
      associated_payments: [],
      bill_date: null,
      bill_id: null,
      bill_number: "",
      financial_summary: {
        outstanding_payables: 0,
        unused_credits: 0,
        balance: 0,
      },
      invc_date: null,
      invc_id: null,
      invc_number: "",
      is_advance: true,
      is_against_bill: true,
      is_used_credits: false,
      lineitems: [],
      net_amount: 0,
      net_payable: 0,
      payment_has_tax: true,
      payment_received_date: null,
      payments_made: 0,
      percentage_pay: 100,
      pod: null,
      pod_id: null,
      pod_stamp_date: null,
      po_id: null,
      remarks: "",
      request_against: "",
      requestor: null,
      seller: null,
      source: "web",
      status_cd: "",
      tds: {
        code: "",
        percentage: 0,
        amount: 0,
      },
      total_amount: 0,
      total_amount_wt: 0,
      total_tax: 0,
      used_credits: 0,
      vas_items: [],
      applied_credits_lineitems: [],
      ...initialState,
    };
  };
};
